import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Box, Flex, Text, Button, Link
} from 'components/ui';
import Divider from 'components/Divider';
import theme from 'style/theme';
import { expandableOptionPaddingLeftSMUI } from 'components/ProductPage/DeliveryOptions/ExpandableDeliveryOptions/ExpandableDeliveryOptions';
import { useSDUBannerNDD } from './hooks/useSDUBannerNDD';

function SDUBannerNDD({ skuTrialEligibility, renderSDULandingPage }) {
    const { message, ctaLabel, showLinkCta, isBannerVisible } = useSDUBannerNDD({ skuTrialEligibility });

    if (!message || !isBannerVisible) {
        return null;
    }

    return (
        <Box
            marginLeft={[-expandableOptionPaddingLeftSMUI, -3]}
            marginRight={[-3, -2]}
            marginBottom={-3}
        >
            <Divider marginTop={[3, 2]} />
            <Flex
                alignItems='center'
                justifyContent='space-between'
                paddingY={[3, 2]}
                paddingX={[4, 3]}
                gap={5}
            >
                <Text
                    is='p'
                    fontSize='sm'
                    css={styles.messageText}
                    children={message}
                />

                {showLinkCta ? (
                    <Link
                        color='blue'
                        onClick={renderSDULandingPage}
                        children={ctaLabel}
                        flexShrink={0}
                    />
                ) : (
                    <Button
                        size='xs'
                        variant='secondary'
                        onClick={renderSDULandingPage}
                        children={ctaLabel}
                        flexShrink={0}
                        minWidth={88}
                    />
                )}
            </Flex>
        </Box>
    );
}

const styles = {
    messageText: {
        // !important needed to override parent element's font-size: 14px (base) from global styles
        // The banner message must be 12px (sm) per design spec, but parent context applies 14px
        fontSize: `${theme.fontSizes.sm}px !important`
    }
};

SDUBannerNDD.propTypes = {
    skuTrialEligibility: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    renderSDULandingPage: PropTypes.func.isRequired
};

export default wrapFunctionalComponent(SDUBannerNDD, 'SDUBannerNDD');
